import { ReactNode } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

import { Colors } from 'constants/colors';
import { FontSizes } from 'constants/font-sizes';

interface Props extends SvgIconProps {
  children: ReactNode;
  iconColor?: string;
  dataTestId?: string;
  iconSize?: string;
}

export const CustomSvgIcon = ({
  children,
  viewBox,
  iconColor,
  dataTestId,
  iconSize,
  ...rest
}: Props) => {
  return (
    <SvgIcon
      {...rest}
      viewBox={viewBox || '0 0 24 24'}
      sx={{
        color: iconColor || Colors.white,
        fontSize: iconSize ? iconSize : FontSizes.fontSize12,
        ...rest.sx,
      }}
      data-testid={dataTestId}
    >
      {children}
    </SvgIcon>
  );
};
